import { render } from "./CampanasTipster.vue?vue&type=template&id=15fa5d25&scoped=true"
import script from "./CampanasTipster.vue?vue&type=script&lang=js"
export * from "./CampanasTipster.vue?vue&type=script&lang=js"

import "./CampanasTipster.vue?vue&type=style&index=0&id=15fa5d25&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fa5d25"]])

export default __exports__